import { render, staticRenderFns } from "./persona.vue?vue&type=template&id=26d85493&scoped=true"
import script from "./persona.vue?vue&type=script&lang=js"
export * from "./persona.vue?vue&type=script&lang=js"
import style0 from "./persona.vue?vue&type=style&index=0&id=26d85493&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26d85493",
  null
  
)

export default component.exports